export default __webpack_public_path__ + "static/media/elite-champion.c8b3d411.svg";